import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';

const pageTitles = {
  '/dashboard': 'Dashboard',
  '/customers': 'Customers',
  '/products':  'Products',
  '/warehouse': 'Warehouse',
  '/shipments': 'Shipments',
  '/tracking':  'Tracking',
  '/reports':   'Reports',
};

export default function Layout() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const title = pageTitles[location.pathname] || 'CargoTrack';
  const sidebarWidth = collapsed ? 64 : 260;

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--bg-primary)' }}>
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div style={{ marginLeft: sidebarWidth, flex: 1, display: 'flex', flexDirection: 'column', transition: 'margin-left 0.25s ease', minHeight: '100vh' }}>
        <header style={{
          height: 64, background: 'var(--bg-secondary)',
          borderBottom: '1px solid var(--border)',
          display: 'flex', alignItems: 'center', padding: '0 28px',
          position: 'sticky', top: 0, zIndex: 50,
          backdropFilter: 'blur(8px)',
        }}>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 700, color: 'var(--text-primary)' }}>{title}</h1>
          <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--success)', boxShadow: '0 0 8px var(--success)' }} />
            <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>API: localhost:8080</span>
          </div>
        </header>
        <main style={{ flex: 1, padding: '32px 28px', animation: 'fadeIn 0.3s ease' }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
